<template>
  <div class="mypooq-inner-wrap">
    <using-break-down-list viewMode="vod"/>
  </div>
</template>
<script>
import UsingBreakDownList from '@/components/mypooq/UsingBreakDownList'
export default {
  components: {
    UsingBreakDownList
  }
}
</script>
